<template>
  <div class="scene-checkpoint-start">
    <div class="back-button">
      <img src="/images/game/back.png" @click="handleBack" />
    </div>

    <img class="sprite .hu__hu__" src="/images/game/sprite-3.png" />

    <div class="title">
      <img :src="title" />
    </div>

    <div class="task">
      <div class="content">
        <div class="subtitle">闯关任务</div>
        <div class="subcontent">答题成绩是A、S、SR可进入下一关;</div>
        <div class="subtitle">支线任务</div>
        <div class="subcontent">{{taskName}};</div>
      </div>
      <img class="button" @click="handleClick" src="/images/game/start.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckpointStartScene",
  computed: {
    title: function() {
      return `/images/game/cp-${this.$store.state.game.currentCheckpointId}-task.png`;
    },
    taskName: function() {
      return this.$store.state.game.gameCheckpoint.get.taskName;
    }
  },

  methods: {
    handleClick() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "CheckpointAnswerScene");
    },
    handleBack() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "MainScene");
    }
  }
};
</script>


<style lang="scss" scoped>
@keyframes ani {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.scene-checkpoint-start {
  width: 1100px;
  height: 560px;
  position: relative;

  background-image: url(/images/game/checkpoint-background.png);
  background-size: cover;
  animation: ani 1.5s;

  .back-button {
    position: absolute;
    width: 80px;
    height: 40px;
    cursor: pointer;

    img {
      width: 100%;
    }
  }

  @keyframes spritemove {
    from {
      left: -310px;
    }

    to {
      left: 148px;
    }
  }

  @keyframes huhu {
    50% {
      transform: translateY(20px);
    }
  }

  .sprite {
    position: absolute;
    top: 190px;
    left: 148px;
    width: 310px;
    height: 325px;

    animation: spritemove 1.5s, huhu 2s infinite;
  }

  .title {
    position: absolute;
    left: 527px;
    top: 111px;
    img {
      height: 51px;
    }
  }

  @keyframes taskmove {
    from {
      right: -410px;
    }

    to {
      right: 202px;
    }
  }

  .task {
    position: absolute;
    width: 410px;
    height: 304px;

    background-image: url(/images/game/task-background.png);
    background-size: cover;

    top: 195px;
    right: 202px;

    animation: taskmove 1.5s;

    .content {
      padding: 55px 45px;
      .subtitle {
        color: #e4c896;
        font-size: 20px;
        // font-weight: bold;
        font-family: "FZFMJW";
        line-height: 40px;
      }
      .subcontent {
        margin-top: 5px;
        color: white;
        font-size: 20px;
        line-height: 40px;
      }
    }

    .background {
      width: 410px;
      height: 304px;
    }

    .button {
      position: absolute;
      top: 250px;
      left: 100px;
      cursor: pointer;
      width: 212px;
      height: 58px;
    }

    .button:hover {
      box-shadow: 0px 2px 27px 7px rgba(250, 100, 0, 0.43);
    }
  }
}
</style>